import { MultiSelectField } from './MultiSelectField'
import { withMultiSelectField } from './withMultiSelectField'

const ConnectedMultiSelectField = withMultiSelectField(MultiSelectField)

export { ConnectedMultiSelectField as MultiSelectField }
